import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Input } from '@angular/core';

import { EpcotConfigService, EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

import { FreeBetToken } from '../../reward-tokens.model';

@Component({
    selector: 'bs-freebet-stake',
    templateUrl: './freebet-stake.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./freebet-stake.component.scss'],
    standalone: false,
})
export class FreeBetStakeComponent {
    @Input() freeBetToken: FreeBetToken | null;
    @Input() isLinear: boolean;

    @HostBinding('class') className = 'freebet-stake reward-tokens-module';
    module = EpcotModule.Betslip;
    isEpcotEnabled = this.epcotConfigService.isEnabled(EpcotModule.Betslip);

    constructor(private epcotConfigService: EpcotConfigService) {}

    @HostListener('click', ['$event'])
    onClick(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
    }
}
